import React from 'react';
import styles from './style.module.css';
import Tooltip from '../tooltip';

export default ({
    input,
    meta: {
        error,
        submitFailed
    } = {},
    type = 'text',
    name = input.name ? input.name : 'input',
    label = false,
    tooltip = false,
    autoComplete = 'off',
    readOnlyValue = false,
    prefix = false,
    min = null,
    max = null,
    placeholder = ''
} = {}) => (
    <div
        className={
            readOnlyValue !== false ?
                styles.readOnly
            : submitFailed && error ?
                styles.inputError
            :
                styles.container
        }
    >
        {
            label &&
            <div className={styles.labelContainer}>
                <label
                    htmlFor={name}
                    className={styles.label}
                >
                    {label}
                </label>
                {
                    tooltip &&
                    <Tooltip content={tooltip}/>
                }
            </div>
        }
        <div className={styles.inputContainer}>
            {
                prefix &&
                <span className={styles.prefix}>{prefix}</span>
            }
            <input
                {...input}
                id={name}
                type={type}
                value={readOnlyValue !== false ? readOnlyValue : input.value}
                readOnly={readOnlyValue !== false}
                onKeyPress={e => {
                    if (e.key === 'Enter') e.preventDefault();
                }}
                className={styles.input}
                autoComplete={autoComplete}
                min={min}
                max={max}
                placeholder={placeholder}
                aria-invalid={submitFailed && error ? 'true' : undefined}
                aria-describedby={submitFailed && error ? `${name}-error` : undefined}
            />
            {
                submitFailed && error &&
                <span className={styles.errorDot}/>
            }
        </div>
        {
            submitFailed && error &&
            error.map((message, i) => <span key={i} id={i === 0 ? `${name}-error` : undefined} className={styles.errorMessage} role='alert'>{message}</span>)
        }
    </div>
);
